module.exports = __webpack_public_path__ + "static/img/head.c0aff3b8.png";